// extracted by mini-css-extract-plugin
module.exports = {"root":"BottomDrawer_root__123p5"};